// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LU-z","inlineTitle":"MU-z","sponsoredAdsWrapper":"NU-z","marketplaceRecosWrapper":"OU-z"};